import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LangProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#050505] min-h-screen text-neutral-100" data-testid="app-root">
      <LangProvider>
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <About />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
      </LangProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
